/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/css';

const box = css`
  flex: 1;
  display: flex;
  align-items: end;
`;

const referrerWrapper = css`
  background: #006bf8;
  border-radius: 16px;
  max-width: 250px;
  margin: 1rem auto 1.5rem;
  color: #fff;
  padding: 10px;
  text-align: center;
`;

const referrerImage = css`
  max-width: 80px;
`;

const referrerHeader = css`
  font-weight: 700 !important;
  margin-bottom: 0.5rem !important;
  font-size: 0.85rem !important;
`;

const referrerBoxMessage = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const referrerMessage = css`
  font-weight: 400 !important;
  margin: 0.2rem auto !important;
  font-size: 0.85rem !important;
`;

const referrerMessageAmmount = css`
  font-weight: 500 !important;
  font-size: 1rem !important;
  margin: 0 5px;
`;

const referrerButton = css`
  background-color: transparent !important;
  border-color: #fff !important;
  font-size: 12px;
  color: #fff !important;
  margin: 0.8rem auto 1rem;
  transition: all 0.5s ease-in-out;
  padding: 0 30px !important;
  height: 35px !important;

  &:hover {
    background-color: rgba(255, 255, 255, 0.85) !important;
    border-color: #006bf8 !important;
    color: #006bf8 !important;
  }
`;

const referrerModalCodeWrapper = css`
  background: rgba(235, 243, 250, 0.5);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  max-width: 200px;
  margin: 1rem auto;
  padding: 0.25rem;
`;

const referrerModalEarns = css`
  margin: 2rem auto 1rem;
  max-width: 350px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  p:last-of-type {
    font-weight: 700 !important;

    span {
      font-weight: 400 !important;
      color: #9e9e9e;
    }
  }
`;

const referrerModalTitle = css`
  &.MuiDialogTitle-root {
    text-align: center;
    margin-bottom: 1rem;
  }
`;

const referrerCloseButton = css`
  &.MuiButtonBase-root {
    position: absolute;
    right: 0;
  }
`;

export const SideBarStyles = {
  box,
  referrerWrapper,
  referrerImage,
  referrerHeader,
  referrerBoxMessage,
  referrerMessage,
  referrerMessageAmmount,
  referrerButton,
  referrerModalCodeWrapper,
  referrerModalEarns,
  referrerModalTitle,
  referrerCloseButton,
};
